
import { Component, forwardRef, Input, EventEmitter, Output, booleanAttribute } from '@angular/core';
import { UploadComponent } from '../upload/upload.component';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { UploadFile } from '../upload-file';
import { Observable, EMPTY } from 'rxjs';
import { UploadSetting } from '../upload-setting';

/**
 * 圖檔上傳
 */
@Component({
  selector: 'tm-img-upload',
  templateUrl: './img-upload.component.html',
  styleUrls: ['./img-upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ImgUploadComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ImgUploadComponent),
      multi: true,
    }
  ]
})
export class ImgUploadComponent extends UploadComponent implements ControlValueAccessor {
  @Input({transform: booleanAttribute}) isCrop = false;
  @Input({transform: booleanAttribute}) showRepresent = true;
  @Input() label: {
    uploadType: string;
    dropAreaText: string;
    representImg: string;
    setRepresentImgTitle: string;
  } = {
    uploadType: '上傳格式:',
    dropAreaText: '拖曳檔案至此範圍內',
    representImg: '代表圖像',
    setRepresentImgTitle: '預設代表圖像',
  };
  @Output() openCrop = new EventEmitter<{ file: UploadFile; setting: UploadSetting}>();
  @Input() crop2Serv = (cropDetail: any): Observable<any> => EMPTY;

  representImg(file: UploadFile, files: UploadFile[]) {
    files.map(x => x.represent = false);
    file.represent = !file.represent;
    this.propagateChange(files);
  }

  onOpenCrop($event: MouseEvent, file: UploadFile, type: string) {
    $event.preventDefault();
    this.openCrop.emit({ file: (file), setting: (this.uploadSetting as any) });
  }

  onUploadFinish(file: UploadFile, uploadFeedBack: any) {
    file.name = uploadFeedBack.name;
    file.fileid = uploadFeedBack.fileid;
    file.thumbnailUrl = uploadFeedBack.thumbnailUrl;
    file.transform = uploadFeedBack.transform;
    this.sortFiles();
    const represent = this.files.map((x) => x.represent).indexOf(true); // 預設代表圖像
    if (represent < 0) { this.files[0].represent = true; }

    this.propagateChange(this.files);
    this.triggerDomChangeEvent();
    this.onUploadFinsihed();
  }
}
